import { combineReducers } from 'redux';
import confirmToLogin from './confirmToLogin'; // @ts-expect-error reducer not yet converted

import twoFactorAuth from './twoFactorAuth'; // @ts-expect-error reducer not yet converted

import twoFactorRecovery from './twoFactorRecovery';
import loginRequirement from './loginRequirement';
export default combineReducers({
  confirmToLogin,
  twoFactorAuth,
  twoFactorRecovery,
  loginRequirement
});